import { Box } from "@mui/system";
import i18next from "i18next";
import React, { useState, useRef } from "react";
import StatusRadioGroup from "../statusRadioGroup/StatusRadioGroup";
import CustomPopover from "../customPopover/CustomPopover";
import styles from "./statusText.module.scss";
import CustomModalDialog from "../modal/CustomModalDialog";
import UpdateVehicleStatus from "../../pages/Vehicles/components/updateVehicleStatus/updateVehicleStatus";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";

export function TooltipWrapper(val, styleval, size) {
  let width = val?.length * 8;
  
  if (val?.length <= size) {
    return <Box className={styleval}>{val}</Box>;
  } else
    return (
      <Tooltip
        disableInteractive
        title={val}
        PopperProps={{
          sx: {
            "& .MuiTooltip-tooltip": {
              width: width,
              padding: "2px 0px",
              textAlign: "center",
              fontSize: "12px",
              color: "common.white",
              backgroundColor: "#808080",
              borderRadius: "5px",
            },
          },
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -5],
              },
            },
          ],
        }}
      >
        <Box className={styleval}>{`${String(val).slice(0, size)}...`}</Box>
      </Tooltip>
    );
}
const StatusText = (props) => {
  const {
    textStyle,
    title = "",
    hasIcon = false,
    customClass = null,
    defaultId = 0,
    defaultStatus = "",
    showPopover = false,
    onStatusChange = null,
    list,
    hasSaveAndViewBtn = false,
    onSaveAndViewClick = null,
    overview=false,
  } = props;
  const [popoverId, setPopoverId] = useState(null);

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const [actionPopover, setActionPopover] = useState(false);

  const [selectedStatus, setSelectedStatus] = useState(defaultStatus);

  const handleToggle = () => {
    if (showPopover) {
      setOpen((prevOpen) => !prevOpen);
      if (open) {
        setPopoverId(`popover-${defaultId}`);
      } else {
        setPopoverId(null);
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleStatusChange = (status) => {
    onStatusChange(defaultId, status);
    handleClose();
  };

  const handleSaveAndViewBtnClick = (status) => {
    onSaveAndViewClick(defaultId, status, true);
    handleClose();
  };
  return (
    <>
      <Box
        className={`${styles.statusTextWrapper} ${textStyle} ${styles[customClass]}`}
        data-testid="StatusText"
        aria-describedby={`popover-${defaultId}`}
        variant="contained"
        ref={anchorRef}
        onClick={(e) => handleToggle()}
      >
        <span className={`${styles.dot}`}></span>

        <Box className={`${styles.headerText}`} data-testid="onclick">
          {overview ? TooltipWrapper(
            i18next.t(title),
            styles.headerText,
            5
            ): i18next.t(title)
            }
        </Box>
        {hasIcon ? (
          <span
            className={
              open ? `${styles.chevronUpIcon}` : `${styles.chevronDownIcon}`
            }
          ></span>
        ) : null}
      </Box>
      <CustomPopover
        anchorEl={anchorRef}
        handleClose={() => handleClose()}
        open={open}
        id={popoverId}
        content={
          <StatusRadioGroup
            defaultStatus={defaultStatus}
            handleClosefn={(status) => handleStatusChange(status)}
            list={list}
            setActionPopover={setActionPopover}
            actionPopover={actionPopover}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            hasSaveAndViewBtn={hasSaveAndViewBtn}
            handleSaveAndViewBtnClick={handleSaveAndViewBtnClick}
          />
        }
      />
      {actionPopover ? (
        <CustomModalDialog
          title={"Change the status to No"}
          isShow={actionPopover}
          onClose={() => setActionPopover(false)}
          className={"modal-dialog"}
          isCloseButton={true}
          hasFooter={false}
        >
          <UpdateVehicleStatus
            handleDelete={() => {
              handleStatusChange(selectedStatus);
              setActionPopover(false);
            }}
            handleCancel={() => setActionPopover(false)}
          />
        </CustomModalDialog>
      ) : null}
    </>
  );
};
export default StatusText;

StatusText.propTypes = {
  textStyle: PropTypes.any,
  title: PropTypes.any,
  hasIcon: PropTypes.any,
  customClass: PropTypes.any,
  defaultId: PropTypes.any,
  defaultStatus: PropTypes.any,
  showPopover: PropTypes.any,
  onStatusChange: PropTypes.any,
  list: PropTypes.any,
  hasSaveAndViewBtn: PropTypes.any,
  onSaveAndViewClick: PropTypes.any,
  overview: PropTypes.any,
};
